import { render, staticRenderFns } from "./clickerfooter.vue?vue&type=template&id=7117add0"
import script from "./clickerfooter.vue?vue&type=script&lang=js"
export * from "./clickerfooter.vue?vue&type=script&lang=js"
import style0 from "./clickerfooter.vue?vue&type=style&index=0&id=7117add0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports